"use client";

import { Suspense } from "react";
import Reveal from "@/app/components/Reveal";

interface LazySectionProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  delay?: number;
}

export default function LazySection({ 
  children, 
  fallback = <div className="py-16 animate-pulse bg-white/5 rounded-lg" />,
  delay = 0 
}: LazySectionProps) {
  return (
    <Suspense fallback={fallback}>
      <Reveal delay={delay}>
        {children}
      </Reveal>
    </Suspense>
  );
}
